export class EncryptedKey {
    constructor(epk, iv) {
        this.encryptedPrivateKey = epk;
        this.iv = iv;
    }
}
